import { useNavigate } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import SideFilmItem from "./SideFilmItem";
import Skeleton from "./Skeleton";

const SideFilmsCol = ({
  films,
  name,
  limitNumber,
  isLoading,
  className = "",
}) => {
  const navigate = useNavigate();

  if (!films || !films.length) return null;

  return (
    <div className={className}>
      <p className="mt-7 mb-6 text-xl font-medium flex justify-between items-center">
        <span className="text-white">{name}</span>{" "}
        <BsThreeDotsVertical size={20} />
      </p>
      <ul className="flex flex-col gap-5">
        {isLoading
          ? new Array(limitNumber).fill("").map((_, index) => (
              <li key={index} className="w-[260px] h-[180px]">
                <Skeleton className="shrink-0 w-full h-full rounded-md" />
              </li>
            ))
          : films.slice(0, limitNumber).map((item) => (
              <li key={item.id}>
                <SideFilmItem item={item} />
              </li>
            ))}
      </ul>
      <button
        className="bg-dark-lighten py-2 w-full rounded-full my-5 hover:brightness-125 hover:text-gray-lighten transition duration-300"
        onClick={() => navigate("/explore")}
      >
        See more
      </button>
    </div>
  );
};

export default SideFilmsCol;
